import React, { useState } from 'react';

import {Field,Form,ErrorMessage} from 'formik'
import {Box,TextField,InputAdornment,FormControl,Typography,useTheme} from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';


import AdapterJalaali from '@date-io/jalaali';
import {tokens} from '../../../../theme';

import { TimePicker } from '@mui/x-date-pickers/TimePicker';






const DateTimePicker = (props) => {
    const{name,label,...rest}=props;
    const [value,setValue]=useState(null);
  
    const theme=useTheme();
    const colors=tokens(theme.palette.mode)

    // .muirtl-1ea1xhh-MuiInputBase-input-MuiOutlinedInput-input
 

     const sxStyle={
      fontFamily: "yekan !important ",
      borderRadius: "4px",
      width: "100%",
      textAlign: "center",
      padding: " 8px",
      "& .muirtl-aqwd4r-MuiFormLabel-root-MuiInputLabel-root": {
        color: colors.grey[100],
      },
     
    }

  return (

        
<Field name={name}>
   
 {

  ({form,field})=>{

  const {setFieldValue}=form;
  const{value}=field;

 
  return ( 
 <FormControl sx={sxStyle}>

<LocalizationProvider 
         dateAdapter={AdapterJalaali}> 
    
         <TimePicker 

         disableMaskedInput
         label={label}  
         id={name}
         value={value}
         {...field}
         {...rest}
         size='small'
         
        onChange={(newValue) => {

            const {h:hourse,m:minutes}=newValue
            let time=`${hourse}:${minutes}`
          setFieldValue(name,newValue._d.toString())

    
          
        }
      }
        renderInput={(params) => <TextField size='small' {...params} inputProps={{ value: params.value === null ? '' : '' }} />}
        // InputProps={{startAdornment:(<InputAdornment position='start'><CalendarMonthOutlinedIcon /></InputAdornment>)}} 
      />
     
     </LocalizationProvider>
 </FormControl>
)
  }

    }
</Field>



            



   
  )
}

export default DateTimePicker